module.exports = __webpack_public_path__ + "img/ic-success.14d04e21.svg";